export default "__VITE_ASSET__mdc$LQvN__"